import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { CoursesInterface } from 'types';
import { getCourseStatus } from 'utils';
import { useCourses, useAuth } from 'contexts';

import './style.scss';

import noImage from 'assets/images/no-image.jpg';
import { IoIosLock } from 'react-icons/io';

export type CardCourseProps = {
  course: CoursesInterface;
  style?: React.CSSProperties;
  className?: string;
  [key: string]: any;
};

export function CardCourse({ course, style, className, ...rest }: CardCourseProps) {
  const { allProgress } = useCourses();
  const { user } = useAuth();

  const getPercent = useMemo(() => {
    let value = 0;

    if (allProgress?.length) {
      const coursePercent = allProgress.find(item => item._id === course._id);

      if (coursePercent) {
        value = coursePercent.percent;
      }
    }

    return value;
  }, [allProgress, course]);

  const totalCourses = () => {
    // Filtra os objetos com os IDs 'startCourse' e 'certificate'
    const totalCourses = allProgress?.filter(item => item._id !== 'startCourse' && item._id !== 'certificate');

    return totalCourses?.length;
  };

  return (
    <div className={`card-course ${className || ''}`} style={style} {...rest}>
      {course._id === 'certificate' && (!user?.challenges['DwdCt7V'] || user?.challenges['DwdCt7V'] < totalCourses) ? (
        <div className="relative flex items-center flex-nowrap" title="Complete todos os cursos">
          <div className="card-course__img overflow-hidden mr-3 lg:mr-5 flex items-center justify-center">
            <img
              src={course.extra?.image?.length ? course.extra?.image : noImage}
              alt={course.title || ' '}
              className="w-full h-full block object-cover transition-transform duration-300 ease-in-out"
            />
          </div>

          <div className="card-course__data">
            <h3 className="mb-2 text-black not-italic font-medium leading-tight">{course.title || ' '}</h3>
            {/* {!!getCourseStatus(getPercent).length && (
              <p className="status text-sm lg:text-base not-italic font-bold leading-tight uppercase">
                {getCourseStatus(getPercent)}
              </p>
            )} */}
            {typeof getPercent === 'number' && getPercent > 0 && user?.challenges['DwdCt7V'] === totalCourses && (
              <p className="progress text-sm lg:text-base text-black not-italic font-bold leading-tight">
                {`${Math.round(getPercent)}% concluído`}
              </p>
            )}
            <IoIosLock className="text-[2.743rem]" />
          </div>
        </div>
      ) : (
        <Link to={`/cursos/${course._id}`} className="relative flex items-center flex-nowrap">
          <div className="card-course__img overflow-hidden mr-3 lg:mr-5 flex items-center justify-center">
            <img
              src={course.extra?.image?.length ? course.extra?.image : noImage}
              alt={course.title || ' '}
              className="w-full h-full block object-cover transition-transform duration-300 ease-in-out"
            />
          </div>

          <div className="card-course__data">
            <h3 className="mb-2 text-black not-italic font-medium leading-tight">{course.title || ' '}</h3>
            {!!getCourseStatus(getPercent).length && (
              <p className="status text-sm lg:text-base not-italic font-bold leading-tight uppercase">
                {getCourseStatus(getPercent)}
              </p>
            )}
            {typeof getPercent === 'number' && getPercent > 0 && (
              <p className="progress text-sm lg:text-base text-black not-italic font-bold leading-tight">
                {`${Math.round(getPercent)}% concluído`}
              </p>
            )}
          </div>
        </Link>
      )}
    </div>
  );
}
